var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M250 18c-80 0-144 65-144 144 0 80 144 338 144 338s144-258 144-338c0-79-65-144-144-144zm0 52a96 96 0 0196 96 96 96 0 01-96 96 96 96 0 01-96-96 96 96 0 0196-96z","fill":"#e74c3c"}));
}

Marker.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Marker;

Marker.default = Marker;
